import React from 'react'
import { Col, Row} from 'react-bootstrap';
import img from '../img/Logistics-Operations.jpg'
import img1 from '../img/New Pics/Freight-Forwarding ERP Software.jpg'
import Image from 'react-bootstrap/Image';
import './AirExportLogisticsSoftware.css';
import './About.css';
import Sidebar from './Sidebar';

function LogisticsOperations() {
  return (
    <>
        <Image className="fade-in responsive-img" src={img} height={500} width="100%" fluid />
    <div className="container my-4">
      <Row>
        <Col xs={12} md={9}>
          <h1 className='mt-5 pt-4 text-danger'>Logistics Operations</h1>
          {/* <Image className='my-2 fade-in' src={img} height={500} fluid /> */}
          <p className='fs-6 text-justify'>CATUS is integrated software solution to manage all business activities that associated with Operational and Financial. Logistics operations software it provides a document management with their attachments to shipments. Main purpose of CATUS software is to provide strategic services to customers, along with a powerful management of Information Exchange Systems. We assured Catus serves its purpose, restricts you for doing lots of unnecessary double entries. Logistics operations software helps you to imagine a successful business model that determines how well your business grows. It brings your business to new heights of integration. It allows you to be access your business from almost anywhere via computer.</p>
          <Image className="my-4 fade-in" src={img1} height={500} fluid />             
          <p className='fs-6 text-justify'>You will be probably shocked to see how many hours you was wasting doing work in your existing environment. We pride on our support services which are second to none and the reason that many of our customers either choose us in the first place, or switched to us subsequently.</p>         
        </Col>

        <Col xs={12} md={3}>
          <Sidebar/>
        </Col>
      </Row>
    </div>
    </>
  )
}

export default LogisticsOperations